import React, { FC } from 'react'
import { ResponseReportApplicationList } from '../../../../states/types/analyze'
import { format } from '../../../../utils/date'
import CsvModule from '../CsvModule'
import TableList from '../TableList'

interface Props {
  date: string
  list: ResponseReportApplicationList
}

const Application: FC<Props> = (props) => {
  const {
    date,
    list,
  } = props

  return (
    <>
      {
        list.data.length ? (
          <section className="page_contents content-area">
            <div className="content-block">
              <div className="block-header">
                <div className="title">
                  アプリケーションリスト
                </div>
                <CsvModule
                  title={
                    `ITガバナンス - アプリケーション ${format(date, "YYYY年MM月")}`
                  }
                  labels={{
                    service_name: "アプリケーション",
                    category_name: "分類名",
                    use_count: "期間内利用人数",
                    use_rate_percent: "使用率",
                    biz_per_member: "合計Biz/人",
                    oldest_use_date: "期間内初回利用日",
                    latest_use_date: "期間内最終利用日",
                    use_time: "期間内利用時間",
                  }}
                  list={
                    list.data.map((value) => (
                      {
                        service_name: value.company_service_name || value.service_name,
                        category_name: value.category_name,
                        use_count: value.use_member_count,
                        use_rate_percent: value.use_rate,
                        biz_per_member: value.biz_per_member,
                        oldest_use_date: value.oldest_use_date,
                        latest_use_date: value.latest_use_date,
                        use_time: value.use_time,
                      }
                    ))
                  }
                />
              </div>
              <div className="block-detail">
                <div className="grid_area">
                  <div className="grid_block no_border">
                    <TableList
                      labels={{
                        service_name: "アプリ名",
                        category_name: "分類名",
                        use_count: "期間内利用人数",
                        use_rate_percent: "使用率",
                        biz_per_member: "合計Biz/人",
                        oldest_use_date: "期間内初回利用日",
                        latest_use_date: "期間内最終利用日",
                        use_time: "期間内利用時間",
                      }}
                      list={
                        list.data.map((value) => (
                          {
                            service_name: value.company_service_name || value.service_name,
                            category_name: value.category_name,
                            use_count: value.use_member_count,
                            use_rate_percent: value.use_rate,
                            biz_per_member: value.biz_per_member,
                            oldest_use_date: value.oldest_use_date,
                            latest_use_date: value.latest_use_date,
                            use_time: value.use_time,
                          }
                        ))
                      }
                      displayLimit={15}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div className="no_data_area">
            <div className="no_data_title">
              データがありません
            </div>
            <div className="no_data_text">
              期間条件や絞り込み条件をご確認ください。
            </div>
          </div>
        )
      }
    </>
  )
}

export default Application
